import { memo, useState } from 'react';
import { useParams } from 'react-router';

import VideoList from '../../components/VideoList';
import { usePlaylistContent } from '../../hooks/usePlaylistContent';
import { useUefatvOptions } from '../../store';

import { useUser } from '@shared/hooks/useUser';
import type { UefatvEditorialContent } from '@shared-types/uefatv.types';

const Playlist = () => {
  const { playlistId } = useParams();
  const { logged } = useUser();
  const { options } = useUefatvOptions();

  const { data, isLoading, loadMoreContent, hasNextPage } = usePlaylistContent(
    playlistId,
    logged,
    options.bpp,
    options.rpp,
  );
  const handleScrolled = () => {
    loadMoreContent();
  };
  const [currentVideo, setCurrentVideo] = useState<UefatvEditorialContent>(data?.items?.at(0));

  if (isLoading) return null;

  return (
    <VideoList
      video={currentVideo ?? data?.items?.at(0)}
      setCurrentVideo={setCurrentVideo}
      onScrolled={handleScrolled}
      container={data}
      hasNextPage={hasNextPage}
    />
  );
};
export default memo(Playlist);
